import { filterTruthy } from '@procureai/util';
import { join, pipe, prepend } from 'ramda';
import { Union } from 'ts-toolbelt';

export const PATH_SEPARATOR = '/';

export const joinPath: (arr: Union.Nullable<string>[]) => string = (arr) => {
  return pipe<[Union.Nullable<string>[]], string[], string[], string>(
    //
    filterTruthy,
    // prepend empty element to get leading separator
    prepend(''),
    join(PATH_SEPARATOR),
  )(arr);
};
